<app-styleguide-specimen [rendering]="rendering" e2eId="styleguide-fieldusage-number">
  <!-- Basic emission of a number field for editing can be done with the *scText component. -->
  <p *scText="rendering.fields.sample"></p>

  <!-- Direct access to the value, which is a JS number, is also supported. -->
  <p>
    JS value type: {{ valueType }}
    <br />
    JS value: {{ fieldValue }}
  </p>
</app-styleguide-specimen>
